/* eslint-disable @typescript-eslint/ban-ts-comment */
import ProjectRole, { ProjectMemberRoleJSON, ProjectMemberRoleType } from '@projectMembers/models/projectRole';
import User, { UserJson } from 'src/new_arch/models/user/user';

export type ProjectMemberJSON = {
	id: number,
	user: UserJson,
	role: ProjectMemberRoleJSON
};

export type ProjectMemberParams = {
	id: number,
	user: User,
	roleType: ProjectMemberRoleType
}

export default class ProjectMember {
	id: number;
	user: User;
	roleType: ProjectMemberRoleType;

	constructor( { id, user, roleType }: ProjectMemberParams ) {
		this.id = id;
		this.user = user;
		this.roleType = roleType;
	}

	get role() {
		return ProjectRole.fromID( this.roleType )!;
	}

	get isOwner() {
		return this.roleType === ProjectMemberRoleType.ProjectOwner;
	}

	get isGuest() {
		return this.user.isGuest;
	}

	hasRole( role: ProjectMemberRoleType ) {
		return this.roleType === role;
	}

	static fromJson( json: ProjectMemberJSON ): ProjectMember {
		return new ProjectMember( {
			id: json.id,
			user: User.fromJson( json.user ),
			roleType: json.role.type
		} );
	}

	toJson(): ProjectMemberJSON {
		return {
			id: this.id,
			user: this.user.toJson(),
			role: {
				id: this.id,
				type: this.roleType
			}
		};
	}
}
